<template>
  <main class="home">
    <HeaderM3 :logoLinkRoute="LinkToHome" :showChat="showChatBot" />
    <div class="main-body d-flex flex-row">
      <div class="w-100">
        <NavigationBar :current-step="1" />
        <div class="container">
          <GoogleAnalyticsEcommerceTracker v-if="enableGoogleAnalytics" />
          <CreditCheck />
        </div>
      </div>
      <InConsoleSidebar v-if="showInconsoleSidebar" />
    </div>
  </main>
</template>

<script setup lang="ts">
import HeaderM3 from "@/apps/merchant3/components/HeaderM3.vue";
import CreditCheck from "@/apps/merchant3/components/steps/credit-check/CreditCheck.vue";
import { RouteName } from "@/apps/merchant3/router/RouteName";
import NavigationBar from "@/apps/merchant3/shared-components/common/NavigationBar.vue";
import GoogleAnalyticsEcommerceTracker from "@/apps/merchant3/helpers/GoogleAnalyticsEcommerceTracker.vue";
import InConsoleSidebar from "@/apps/merchant3/components/in-console/ui/InConsoleSidebar.vue";
import { ref, computed, onMounted } from "vue";
import useConfigurations from "@/apps/merchant3/hooks/useConfigurations";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { CheckoutStep } from "@/apps/merchant3/enums/checkoutStepEnum";
import useCartPersistState from "@/apps/merchant3/hooks/useCartPersistState";
import { RoutesPageSteps } from "@/apps/merchant3/router/RoutesPageSteps";

const route = useRoute();
const store = useStore();

const LinkToHome = ref(RouteName.M3Welcome);
const { flows, globalComponents, loadConfigs } = useConfigurations();
const currentStep = route.meta.step as CheckoutStep;

const cartTag = computed(() => store.state.carts.cartTag);
const showInconsoleSidebar = computed(
  () =>
    globalComponents.value?.showInConsoleMessages ||
    globalComponents.value?.showInConsoleTraining ||
    false
);
const showChatBot = computed(
  () => globalComponents.value?.showChatBot ?? false
);

const enableGoogleAnalytics = computed(() => {
  return flows.value?.isEcommerce;
});

onMounted(async () => {
  useCartPersistState(() => {
    loadConfigs(cartTag.value, currentStep);
    store.dispatch("carts/setStep", RoutesPageSteps.CreditCheckPermission);
    return true;
  });
});
</script>
